// extracted by mini-css-extract-plugin
export default {"render-sales-receipt-modal-form-content":"styles_render-sales-receipt-modal-form-content__TzW3Z"};